export default __webpack_public_path__ + "static/media/calendar-lite.37eced5e.svg";